import type { Transaction } from "@rocicorp/zero";
import { sql } from "drizzle-orm";

import type { DbTransaction } from ".";

const advisoryLockNamespaces = {
  mealPlan: 1_731,
  plannedMeal: 1_732,
  brandedFoodBarcodeIngest: 1_733,
  mealPlanningSession: 1_734,
  groupInvite: 1_735,
  space: 1_736,
} as const;

export type AdvisoryLockKind = keyof typeof advisoryLockNamespaces;
export type AdvisoryLockMode = "shared" | "exclusive";

export async function acquireAdvisoryLock(
  tx: DbTransaction,
  kind: AdvisoryLockKind,
  key: string,
  mode: AdvisoryLockMode = "exclusive",
): Promise<void> {
  const namespace = advisoryLockNamespaces[kind];
  if (mode === "shared") {
    await tx.execute(sql`select pg_advisory_xact_lock_shared(${namespace}, hashtext(${key}))`);
    return;
  }

  await tx.execute(sql`select pg_advisory_xact_lock(${namespace}, hashtext(${key}))`);
}

export async function acquireAdvisoryLockIfServer(
  tx: Transaction,
  kind: AdvisoryLockKind,
  key: string,
  mode: AdvisoryLockMode = "exclusive",
): Promise<void> {
  if (tx.location !== "server") {
    return;
  }

  await acquireAdvisoryLock(tx.dbTransaction.wrappedTransaction, kind, key, mode);
}
